site.hero = {
	owl: $('#owl-hero'),

	init: function() {
		site.hero.owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
		site.hero.owl.owlCarousel({
			loop:true,
			navigation:true,
			navText:["",""],
			dots: true,
			autoplay: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			autoplayTimeout: 8000,
			autoplayHoverPause: true,
			touchDrag: true,
			mouseDrag: true,
			items: 1
		});
	}
};

site.inits.push('site.hero.init()');
